export const HIGHCHARTS_UPDATE_DEBOUNCE_VALUE = 500;
export const DEFAULT_INPUT_DEBOUNCE_TIME = 1000;
export const DEFAULT_RECOMMENDATION_DEBOUNCE_TIME = 2000;
export const DEFAULT_BATCHER_DEBOUNCE_TIME = 300;

/**
 * Number of concurrent requests  from _each_ prognosis service
 */
export const ICON_BASE_PATH = "https://elements.storebrand.no/din-pensjonsplan/svg";

/*
 * BreakpointObserver media queries
 */

export const BREAKPOINT_LG_MIN = 992;
export const BREAKPOINT_MD_MIN = 768;

export const OBSERVER_BREAKPOINT_MD_MAX = `(max-width: ${991}px)`;
export const OBSERVER_BREAKPOINT_MD_MIN = `(min-width: ${768}px)`;
export const OBSERVER_BREAKPOINT_LG_MIN = `(min-width: ${BREAKPOINT_LG_MIN}px)`;

/** Avtaler (contracts v2) page only: actions layout and bottom-sheet modals. Not a system breakpoint. */
export const BREAKPOINT_CONTRACTS_PAGE_MIN = 840;
export const OBSERVER_BREAKPOINT_CONTRACTS_PAGE_MIN = `(min-width: ${BREAKPOINT_CONTRACTS_PAGE_MIN}px)`;

export const LARGE_DIALOG_WINDOW_WIDTH = "672px";

export const NON_BREAKING_SPACE = "\xA0";
export const MINUS_SIGN = "\u2212";

export const RUNNING_JOBS_WARNING_DEBOUNCE_TIME = 10000;
export const RUNNING_JOBS_DEBOUNCE_TIME = 750;

export const DEFAULT_TIMEOUT = 3000;

export const HYPHEN_SEPARATOR = " - ";

export const BULLET_SEPARATOR = " • ";

export const CUSTOMIZED_SIMULATION_AGE_DROPDOWN_VALUE = 0;

export const NUMBER_OF_PADDED_COLUMNS_IN_AGREEMENTS_CHART = 2;

export const HIGHCHARTS_YAXIS_BREAKPOINT = 600;

export const SURVEY_IN_SMART_PENSION = {
  key: "survey",
  value: "smart-pensjon",
};

/**
 * HTTP Headers
 */
export const HTTP_HEADER_CLIENT_ID = {
  key: "Clientid",
  value: "smart-pensjon-web",
};
export const HTTP_HEADER_CORRELATION_ID = "x-correlation-id";
export const HTTP_HEADER_REQUEST_ID = "x-request-id";
